import { Icon } from 'components'
import styles from './styles.module.scss'

const EmptyState = () => (
  <div className={styles.emptyState}>
    <Icon color="element-light" name="shield-off" width={72} height={72} />
    <h2>Sem eventos</h2>
    <h3>Não há eventos registrados para esta data</h3>
  </div>
)

export default EmptyState
